/**
 * Identidade do atendente e WhatsApp de destino por plataforma (HN-3170).
 *
 * Chave = `unity.reference` (mesmo `UNITY_ID` usado em
 * `postgraduate-agendor-funnel.ts` e na rota de webhook de reset de
 * senha) — única fonte já existente no código para distinguir as marcas
 * em runtime, sem depender de `process.env` (o chat roda no client).
 */

export interface PostgraduateChatPlatformConfig {
  /** Nome do atendente exibido no header e na saudação. */
  readonly attendantName: 'Edu' | 'Ester'
  /** Pronome usado na mensagem "Olá, sou {pronome} {nome}." */
  readonly attendantPronoun: 'o' | 'a'
  /** WhatsApp da pós-graduação correspondente, só dígitos com DDI. */
  readonly whatsappNumber: string
}

const EDUHOT_UNITY_ID = 'UE9E55FE9'
const ESTETUS_UNITY_ID = 'UD2A7AE51'
const SOEDUCADOR_UNITY_ID = 'U5071E012'

const POSTGRADUATE_CHAT_CONFIG: Record<string, PostgraduateChatPlatformConfig> = {
  [SOEDUCADOR_UNITY_ID]: {
    attendantName: 'Edu',
    attendantPronoun: 'o',
    whatsappNumber: '558820181155',
  },
  [ESTETUS_UNITY_ID]: {
    attendantName: 'Ester',
    attendantPronoun: 'a',
    whatsappNumber: '558820181150',
  },
  [EDUHOT_UNITY_ID]: {
    attendantName: 'Edu',
    attendantPronoun: 'o',
    whatsappNumber: '558820181151',
  },
}

/**
 * `null` fora das 3 plataformas de pós listadas na task (Eduhot, Estetus,
 * SóEducador) — quem chama decide o que fazer (hoje: não renderizar o chat).
 */
export function getPostgraduateChatConfig(
  unityReference: string | null | undefined
): PostgraduateChatPlatformConfig | null {
  if (!unityReference) {
    return null
  }
  return POSTGRADUATE_CHAT_CONFIG[unityReference] ?? null
}
